import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, SubmissionError } from 'redux-form'
import { Form, TextArea, Button, Confirm, Dropdown, Input } from  'semantic-ui-react'

import { Cont } from './styled'
import ChatModal from './ChatModal'
import { StdCard } from 'components'
import { approverPOAction } from 'ducks/purchaseOrder'
import FileInput from './FileInput'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import r from 'reactotron-react-js'

export const renderTextArea = ({ input, meta: { touched, error, warning } }) => {
  return (
    <div style={{ width:'100%', display: 'flex', flexDirection: 'column'}}>
      <TextArea className='field-input' {...input} rows={3} />
      <div className='field-label'>
        {touched &&
          ((error && <span style={{ color: 'red' }}>{error}</span>) ||
           (warning && <span style={{ color: 'red' }}>{warning}</span>)
          )}
      </div>
    </div>
  )
}

export const renderDropdown = props => {
  return (
    <div>
      <Dropdown 
        selection
        value={props.input.value}
        fluid
        search
        onChange={(e, data) => props.input.onChange(data.value)}
        placeholder={props.label} 
        options={props.option}
      />
    </div>
  )
}

export const renderInput = props => {
  const { input, disabled, placeholder, meta: { touched, error, warning }} = props
  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
    <Input 
      {...input}
      disabled={disabled || false}
      placeholder={placeholder || ''} />
      <div className='field-label'>
        {touched &&
          ((error && <span style={{ color: 'red' }}>{error}</span>) ||
           (warning && <span style={{ color: 'red' }}>{warning}</span>)
          )}
      </div>
    </div>
  )
}

const Approve = (props) => {
  const { valueForm, handleSubmit, approverPOAction, change, isNewVersion } = props
  const approverAction = valueForm.approverAction || []
  const sn = valueForm.sn || ''

  const [showApprovalChat, setShowApprovalChat] = useState(false)
  const [submitActionName, setSubmitActionName] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)

  useEffect(() => {
    if (approverAction.includes('UploadByPurchase') && valueForm.status === 13 &&
       ['Duty01', 'Duty02'].includes(valueForm.stampDutyType)) {
        if (valueForm.dutyType === undefined || valueForm.dutyType === null ||valueForm.dutyType === '') {

          change('dutyType', 'stampDuty')
        }
      }
  }, [valueForm.id])

  return (
    approverAction.length === 0 ? null :
    <StdCard title='Action for Approval' highlight style={{ marginTop: '1rem' }} enableCollapse={false}>
      <Cont>
        <Form onSubmit={handleSubmit(() => submitValidate(valueForm))}>
          <div style={{ display:'flex', flexDirection: 'column' }}>
            <Field 
              name='comment' 
              label='Your Comment' 
              type={type.textArea}
              containerStyle={{ marginRight: '0px' }}
              component={FieldInput} />
            {
              (approverAction.includes('UploadByPurchase') && ['Duty01', 'Duty02'].includes(valueForm.stampDutyType)) ?
                valueForm.status === 13 ?
                  <React.Fragment>
                    <div className='title'>Upload Stamp Duty</div>
                      <div className='rowFields'>
                        <Field 
                          name='dutyType' 
                          type={type.radio} 
                          editable={false}
                          options={[{
                            text:'E-Stamp',
                            value:'eStamp'
                          }, {
                            text:'Stamp Duty',
                            value:'stampDuty'
                          }]} 
                          component={FieldInput} />
                      </div>
                      <div className='rowFields'>
                        {
                          valueForm.dutyType === 'eStamp' ?
                            <Field name='PO27' label='Stamp Duty Receipt' require component={FileInput} /> :
                          valueForm.dutyType === 'stampDuty' ?
                          <div>
                            <b>กรุณาอัพโหลดใบสั่งซื้อ(PO) ที่ลงนามโดย Vendor และติดอากรแสตมป์เรียบร้อยแล้ว</b>
                            <Field name='PO28' require label='PO Affixed Stamp Duty' component={FileInput} />
                          </div> : null
                        }
                      </div>
                  </React.Fragment> :
                  isNewVersion ? 
                    <Field name='po03' label='Attachments' component={FileInput} />  :
                    <div>
                      <b>กรุณาอัพโหลดใบสั่งซื้อ(PO) ที่ลงนามโดย Vendor และติดอากรแสตมป์เรียบร้อยแล้ว</b>
                      <Field name='PO28' require label='PO Affixed Stamp Duty' component={FileInput} />
                    </div> :
                <Field name='po03' label='Attachments' component={FileInput} /> 
            }
            <div style={{ marginTop: '1rem' }}>
              {
                approverAction.map(a => 
                  <Button 
                    type='submit' 
                    color={a === 'Reject' || a === 'Cancel' || a === 'ReviseToVendor' ? 'red' : 'green'} 
                    onClick={() => setSubmitActionName(a)}
                  >
                    {a === 'Reject' ? 'Reject' : 
                     a === 'SubmitToVendor' ? 'Submit to vendor' : 
                     a === 'UploadByPurchase' ? 'Upload By Purchase' : 
                     a === 'ReviseToVendor' ? 'Revise To Vendor' :a }
                  </Button>
                )
              }
            </div>
          </div>
          <ChatModal open={showApprovalChat} onCloseClick={() => setShowApprovalChat(!showApprovalChat)}/>
          <Confirm
            size='mini'
            open={showConfirm}
            content={submitActionName === 'UploadByPurchase'?'Are you sure the PO signed already attach?':'Are you sure?'}
            onCancel={() => setShowConfirm(false)}
            onConfirm={() => submitAction()}
          />  
        </Form>
      </Cont>
    </StdCard>
  )

  function submitValidate(values){
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100) // simulate server latency
    .then(() => {
      if(submitActionName.toLowerCase() === 'reject' || 
         submitActionName.toLowerCase() === 'cancel' ||
         submitActionName.toLowerCase() === 'revisetovendor'
        ) {
        if(!values.comment||values.comment.trim().length === 0) {
          throw new SubmissionError({ comment: 'Required!'})
        }
      } else if (submitActionName === 'UploadByPurchase') {
        if (['Duty01', 'Duty02'].includes(valueForm.stampDutyType)) {
          if (valueForm.status === 13) {
            if (values.dutyType === undefined || values.dutyType === null || values.dutyType === '') {
              throw new SubmissionError({ dutyType: 'Require!'})
            } else {
              if (valueForm.dutyType === 'eStamp') {
                if ((valueForm.PO27 || []).length === 0) {
                  throw new SubmissionError({ PO27: 'Require!'})
                }
              }
        
              if (valueForm.dutyType === 'stampDuty') {
                if ((valueForm.PO28 || []).length === 0) {
                  throw new SubmissionError({ PO28: 'Require!'})
                }
              }
            }
          } else {
            if (isNewVersion) {
              if (values.po03 === undefined || 
                values.po03 === null || 
                values.po03 === '' || 
                values.po03.length === 0) {
                  throw new SubmissionError({ po03: 'Please attach the PO signed by vendor.'})
              }
            } else {
              if (values.PO28 === undefined || 
                values.PO28 === null || 
                values.PO28 === '' || 
                values.PO28.length === 0) {
                throw new SubmissionError({ PO28: 'Please attach the PO Affixed Stamp Duty and signed by vendor.'})
              }
            }
          }
        } else {
          if (values.po03 === undefined || 
            values.po03 === null || 
            values.po03 === '' || 
            values.po03.length === 0) {
              throw new SubmissionError({ po03: 'Please attach the PO signed by vendor.'})
            }
        }
        
      }
      setShowConfirm(true)
    })
  }

  function submitAction() {
    setShowConfirm(false)
    approverPOAction({
      ...props.valueForm,
      docId: valueForm.id,
      sn: sn,
      action: submitActionName,
    }, props.history)
  }
}

const mapStateToProps = (state) => ({
  initialValues: {
    comment:''
  },
  valueForm : getFormValues('formPO')(state)||{}
})

const mapDispatchToProps = {
  approverPOAction
}

export default connect(mapStateToProps, mapDispatchToProps)(Approve)